import { render } from "./PortfolioDistributionChart.vue?vue&type=template&id=5403eb3b&ts=true"
import script from "./PortfolioDistributionChart.vue?vue&type=script&lang=ts"
export * from "./PortfolioDistributionChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__